var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureTileIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 72,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.078%",
    y1: "100%",
    x2: "0%",
    y2: "7.585%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006DCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#338BF8",
    offset: "39.97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23FAD2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 36,
    cy: 36,
    r: 36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7E5FF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "d",
    width: 50,
    height: 32,
    rx: 2
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-40%",
    y: "-50%",
    width: "180%",
    height: "225%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.207843137 0 0 0 0 0.145098039 0 0 0 0 0.82745098 0 0 0 0.16 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7E5FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "g",
    x: 11,
    y: 10,
    width: 50,
    height: 32,
    rx: 2
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-40%",
    y: "-50%",
    width: "180%",
    height: "225%",
    filterUnits: "objectBoundingBox",
    id: "f"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.207843137 0 0 0 0 0.145098039 0 0 0 0 0.82745098 0 0 0 0.16 0",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a",
    transform: "translate(28)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41 14)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#e)",
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41 14)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#f)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#h)",
    xlinkHref: "#g"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon01);
export default __webpack_public_path__ + "static/media/feature-tile-icon-01.b200de9fb2a3eabd7d7a3ca3cccadf53.svg";
export { ForwardRef as ReactComponent };